import {
	animate,
	state,
	style,
	transition,
	trigger,
} from '@angular/animations';
import { Component } from '@angular/core';

import { UserApplicationPort } from 'user/port/user-application.port';

import { AppController } from './app.controller';
import { AppService } from './app.service';

@Component({
	selector: 'spr-root',
	templateUrl: './app.component.html',
	animations: [
		trigger('sideBarStatus', [
			transition('opened <=> closed', [animate(150)]),
			state('closed', style({ transform: 'translateX(-100%)' })),
			state('opened', style({ transform: 'translateX(0)' })),
		]),
		trigger('chatStatus', [
			transition('* => opened', [
				style({ transform: 'translateX(100%)' }),
				animate(150),
			]),
			transition('* => void', [
				animate(150, style({ transform: 'translateX(100%)' })),
			]),
			transition('* <=> closed', [animate(150)]),
			state('closed', style({ transform: 'translateX(100%)' })),
			state('opened', style({ transform: 'translateX(0)' })),
		]),
	],
	host: {
		class: 'h-full flex items-stretch flex-col',
	},
})
export class AppComponent {
	constructor(
		private _service: AppService,
		public controller: AppController,
		private _userApplicationPort: UserApplicationPort
	) {}

	public onFocusModeClick() {
		this.controller.disableFocusMode();
	}
}
